<template>
  <div v-if="isLoad" class="container-wrapper service-request-page">
    <div v-if="activeLoading" class="spinner-container">
      <div class="lds-dual-ring" />
    </div>
    <section class="container" :class="{ 'container-disabled': activeLoading }">
      <h1 v-if="getMain.title">{{ getMain.title }}</h1>

      <div class="service-request-page__form">
        <div class="service-request-page__form-fields">
          <BaseInput
            v-model="form.vin_number"
            :label="getMain.form.vin_number.label"
            :required="getMain.form.vin_number.required"
            :errorMsg="errorMsgs.vin_number"
            class="service-request-page__form-input"
          />
          <BaseInput
            v-model="form.model"
            :defaultValue="defaultForm.model"
            :label="getMain.form.model.label"
            :required="getMain.form.model.required"
            :errorMsg="errorMsgs.model"
            class="service-request-page__form-input"
          />
          <BaseInput
            v-model="form.state_number"
            :label="getMain.form.state_number.label"
            :required="getMain.form.state_number.required"
            :errorMsg="errorMsgs.state_number"
            class="
          service-request-page__form-input"
          />
          <div
            class="service-request-page__form-input"
          />
          <BaseSelect
            v-if="!$route.query.city"
            v-model="form.city_id"
            :items="getMain.form.city_id.items"
            :label="getMain.form.city_id.label"
            :disabled="$route.query.city"
            :placeholder="getMain.form.city_id.placeholder"
            :required="getMain.form.city_id.required"
            :errorMsg="errorMsgs.city_id"
            class="service-request-page__form-input"
            @input="fetchDealer"
          />
          <BaseSelect
            v-if="!$route.query.dealer"
            v-model="form.dealer_id"
            :items="dealerItems"
            :label="getMain.form.dealer_id.label"
            :disabled="$route.query.dealer"
            :placeholder="getMain.form.dealer_id.placeholder"
            :required="getMain.form.dealer_id.required"
            :errorMsg="errorMsgs.dealer_id"
            class="service-request-page__form-input"
            @input="resetService"
          />
          <BaseSelect
            v-model="form.service_id"
            :items="serviceItems"
            :disabled="!form.dealer_id"
            :label="getMain.form.service_id.label"
            :placeholder="getMain.form.service_id.placeholder"
            :required="getMain.form.service_id.required"
            :errorMsg="errorMsgs.service_id"
            class="service-request-page__form-input"
          />
          <div
            v-if="!getOptionsSubService.length"
            class="service-request-page__form-input"
          />
          <BaseSelect
            v-if="getOptionsSubService.length"
            v-model="form.sub_service_id"
            :label="getMain.form.sub_service_id.label"
            :items="getOptionsSubService"
            :placeholder="getMain.form.sub_service_id.placeholder"
            :required="getMain.form.sub_service_id.required"
            :errorMsg="errorMsgs.sub_service_id"
            class="service-request-page__form-input"
            @input="selectSubSelect"
          />
          <BaseInput
            v-model="form.first_name"
            :label="getMain.form.first_name.label"
            :required="getMain.form.first_name.required"
            :errorMsg="errorMsgs.first_name"
            class="service-request-page__form-input"
          />
          <BaseInput
            v-model="form.last_name"
            :label="getMain.form.last_name.label"
            :required="getMain.form.last_name.required"
            :errorMsg="errorMsgs.last_name"
            class="service-request-page__form-input"
          />
          <!-- <BaseSelect
            v-model="form.appeal"
            :items="getMain.form.appeal.items"
            :label="getMain.form.appeal.label"
            :placeholder="getMain.form.appeal.placeholder"
            :required="getMain.form.appeal.required"
            :errorMsg="errorMsgs.appeal"
            class="service-request-page__form-input"
          /> -->
          <BaseInput
            v-model="form.phone"
            :label="getMain.form.phone.label"
            :required="getMain.form.phone.required"
            :errorMsg="errorMsgs.phone"
            type="tel"
            class="service-request-page__form-input"
          />
          <!-- <BaseInput
            v-model="form.middle_name"
            :label="getMain.form.middle_name.label"
            :required="getMain.form.middle_name.required"
            :errorMsg="errorMsgs.middle_name"
            class="service-request-page__form-input"
          /> -->
          <BaseInput
            v-model="form.email"
            :label="getMain.form.email.label"
            :required="getMain.form.email.required"
            :errorMsg="errorMsgs.email"
            type="email"
            class="service-request-page__form-input"
          />
          <BaseDatePicker
            v-if="getMain.form && getMain.form.date_time && showDatePicker"
            ref="datePicker"
            :label="getMain.form.date_time.label"
            :required="getMain.form.date_time.required"
            :buttonsText="getMain.form.date_time.buttonText"
            :options="datePickerOptions"
            :errorMsg="errorMsgs.date_time"
            :class="[
              'service-request-page__form-input',
              { disabled: !datePickerOptions && dealerItems }
            ]"
            @input="form.date_time = $event"
          />
          <BaseSelect
            v-model="form.contact_method"
            :items="getMain.form.contact_method.items"
            :label="getMain.form.contact_method.label"
            :placeholder="getMain.form.contact_method.placeholder"
            :required="getMain.form.contact_method.required"
            :errorMsg="errorMsgs.contact_method"
            class="service-request-page__form-input"
          />
          <BaseSelect
            v-if="form.service_id === undefined || getOptionsMobility.length"
            v-model="form.mobility_id"
            :items="getOptionsMobility"
            :label="getMain.form.mobility_id.label"
            :placeholder="getMain.form.mobility_id.placeholder"
            :required="getMain.form.mobility_id.required"
            :errorMsg="errorMsgs.mobility_id"
            class="service-request-page__form-input"
          />
          <BaseInput
            v-model="form.comment"
            :label="getMain.form.comment.label"
            :required="getMain.form.comment.required"
            :errorMsg="errorMsgs.comment"
            type="textarea"
            class="service-request-page__form-input"
          />
          <!-- COLUMN 2 -->
        </div>
      </div>

      <div v-if="getMain.hintText" class="service-request-page__editor-wrapper">
        <p class="service-request-page__editor" v-html="getMain.hintText" />
      </div>

      <div class="service-request-page__policy">
        <BaseCheckbox v-model="form.policy" :errorMsg="errorMsgs.policy">
          <span
            class="simple-link"
            @click="setPolicy"
          >
            {{ getMain.policyLabel }}
            <router-link
              to="/policy"
              class="simple-link"
            >
              {{ getMain.policyLink }}
            </router-link>
          </span>
        </BaseCheckbox>
      </div>

      <div class="service-request-page__pd">
        <BaseCheckbox v-model="form.marketing" :errorMsg="errorMsgs.marketing">
          <span
            class="simple-link"
            @click="setPolicy"
          >
            {{ getMain.marketingConsentLabel }}
            <router-link to="/marketing" class="simple-link">
              {{ getMain.marketingConsentLink }}
            </router-link>
          </span>
        </BaseCheckbox>
      </div>

      <div class="service-request-page__submit-button-container">
        <BaseButton :disabled="!form.policy" @click="submitForm">
          {{ getMain.submitButtonText }}
        </BaseButton>
      </div>
    </section>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'

  export default {
    name: 'MainPage',

    data () {
      return {
        pageData: {},
        form: '',
        dealerItems: (this.getMain && this.getMain.form.dealer_id.items) || [],
        componentReady: false,
        showDatePicker: true,
        errorMsgs: {},
        mobilities: [],

        isChangedForm: false,
        defaultForm: {},
        activeLoading: false
      }
    },

    computed: {
      ...mapGetters(['getMain', 'isLoad', 'getPhoneType']),
      ...mapState(['currentLang']),

      getOptionsSubService () {
        if (this.dealerItems && this.dealerItems.length && this.form.service_id) {
          // eslint-disable-next-line camelcase
          return this.dealerItems.filter(item => item.value === this.form.dealer_id)[0].sub_services
            .filter(item => +item.service_id === +this.form.service_id)
            .map(item => {
              return {
                value: item.value,
                text: item.text
              }
            })
        }
        return []
      },

      getOptionsMobility () {
        if (this.dealerItems && this.dealerItems.length) {
          if (this.dealerItems
            .filter((item) => item.value === this.form.dealer_id).length) {
            // eslint-disable-next-line camelcase
            return this.dealerItems
              .filter((item) => item.value === this.form.dealer_id)[0]
              .mobility
              .map((item) => {
                return {
                  value: item.value,
                  text: item.text
                }
              })
          }
        }
        return []
      },

      datePickerOptions () {
        const dealerId = this.form.dealer_id
        let items = this.getMain.form.date_time.options
        this.dealerItems.forEach(({ value, workPeriod, requestServiceIn }) => {
          if (value === dealerId) {
            items = { datePickerStep: 60, schedule: workPeriod, requestServiceIn, dealerId: value }
          }
        })
        return items
      },
      queryCity () {
        const cityId = Number(this.removeQueryString(this.$route.query.city))
        return isNaN(cityId) ? undefined : cityId
      },
      serviceItems () {
        const dealerId = this.form.dealer_id
        let items = (this.getMain && this.getMain.form.service_id.items) || []
        this.dealerItems.forEach(({ value, services }) => {
          if (value === dealerId) {
            items = services
          }
        })
        return items
      }
    },
    watch: {
      'getOptionsMobility': {
        handler (value) {
          if (value.length) {
            this.form.mobility_id = value[0].value
          }
        }
      },
      'dealerItems': {
        handler () {
          if (this.dealerItems.length === 1) {
            this.form.dealer_id = this.dealerItems[0].value
          }
        }
      },
      'form.service_id': {
        handler () {
          this.form.sub_service_id = ''
        }
      },
      'form.vin_number': {
        handler (e) {
          if (e.replace(/\s/g, '').length === 17) {
            document.querySelector('div').focus()
            var tmp = document.createElement('input')
            document.body.appendChild(tmp)
            tmp.focus()
            document.body.removeChild(tmp)
            this.getVinCodeField(e)
          }
        }
      },
      form: {
        deep: true,
        handler (e) {
          const emptyData = [
            e.periodId,
            e.appeal,
            e.first_name,
            e.last_name,
            e.state_number,
            e.middle_name,
            e.email,
            e.date_time,
            e.comment,
            e.vin_number
          ]
          if (
            (emptyData.some(item => item !== '') ||
            e.model !== (this.removeQueryString(this.$route.query.model) || '') ||
            e.dealer_id !==
            (this.$route.query.dealer && Number(this.removeQueryString(this.$route.query.dealer))) ||
            e.city_id !==
            (this.$route.query.city && Number(this.removeQueryString(this.$route.query.city))) ||
            e.service_id !==
            (this.$route.query.service &&
              Number(this.removeQueryString(this.$route.query.service))) ||
            (e.phone !== this.getPhoneType &&
            e.phone !== '+373-' &&
            e.phone !== '+380-' && e.phone !== '') ||
            e.contact_method !== 1 ||
            e.policy !== false) &&
            !this.isChangedForm
          ) {
            this.changedForm()
          }
        }
      }
    },

    created () {
      if (this._.get(this.$route, 'query.country')) {
        this.$store.commit('setCurrentCountry', this.removeQueryString(this.$route.query.country))
      }

      if (this._.get(this.$route, 'query.lang')) {
        this.$store.commit('setCurrentLang', this.removeQueryString(this.$route.query.lang))
      }

      if (this.queryCity) {
        this.fetchDealer(this.queryCity, true)
      }
      this.form = this.getDefaultForm()
    },

    mounted () {
      if (this._.get(this.$route, 'query.vin')) {
        this.form.vin_number = this._.get(this.$route, 'query.vin')
      }
      // dataLayer start
      window.dataLayer = window.dataLayer || []
      window.tngaDataLayer = window.tngaDataLayer || {}

      const page = {
        category: 'tools',
        subCategory: 'form',
        sectionlv1: 'forms',
        sectionlv2: 'book-service',
        language: _.get(this, 'currentLang', '')
      }

      const form = {
        name: 'lead-book-service',
        step: 'form-start',
        conversion: '0'
      }

      window.tngaDataLayer = { page, form }
    // dataLayer end
    },

    methods: {
      ...mapActions(['submitServiceRequest']),
      removeQueryString (url) {
        if (url) {
          return url.split('?')[0]
        }
        return url
      },
      setPolicy () {
        const stockMarketing = {
          marketingConsentText: this.getMain.marketingConsentText,
          formSubmitUrl: this.getMain.marketingLink,
          closeButtonText: this.getMain.closeButtonText
        }

        const stockPolicy = {
          policyText: this.getMain.policyText,
          formSubmitUrl: this.getMain.policyLabel,
          closeButtonText: this.getMain.closeButtonText
        }

        localStorage.setItem('stockPolicy', JSON.stringify(stockPolicy))
        localStorage.setItem('marketing', JSON.stringify(stockMarketing))

        this.$store.commit('setMarketing', stockMarketing)
        this.$store.commit('setStockPolicy', stockPolicy)
      },

      getVinCodeField (e) {
        this.getVINCodeAction(e)
      },
      async getVINCodeAction (code) {
        try {
          this.activeLoading = true
          const { data } = await window.axios.get(`/service-check-vin/${code}`)
          this.activeLoading = false
          if (data.modelName && data.modelName.length && data.status !== 'UNKNOWN') {
            this.defaultForm.model = ''
            this.form.model = ''

            this.form.model = data.modelName
            this.defaultForm.model = data.modelName
          }
        } catch (error) {
          this.activeLoading = false
        }
      },
      getDefaultForm () {
        return {
          model: this.removeQueryString(this.$route.query.model) || '',
          periodId: '',
          dealer_id: this.$route.query.dealer && Number(this.removeQueryString(this.$route.query.dealer)),
          appeal: '',
          first_name: '',
          last_name: '',
          state_number: '',
          middle_name: '',
          city_id: this.$route.query.city && Number(this.removeQueryString(this.$route.query.city)),
          service_id:
            this.$route.query.service && Number(this.removeQueryString(this.$route.query.service)),
          phone: this.getPhoneType === '+373' ? '' : this.getPhoneType,
          email: '',
          date_time: '',
          comment: '',
          vin_number: '',
          contact_method: 1,
          policy: false,
          sub_service_id: '',
          marketing: false,
          mobility_id: ''
        }
      },
      changedForm () {
        this.pushDataToDataLayer(
          {
            events: {
              name: 'formevent',
              componentName: 'book-service',
              componentGroup: 'forms',
              action: 'form-step',
              label: 'form-fill-start'
            },
            forms: {
              name: 'lead-book-service',
              step: 'form-fill-start',
              conversion: '0'
            }
          },
          true
        )
        this.isChangedForm = true
      },
      async clearForm () {
        this.form = this.getDefaultForm()
        const inputs = [
          ...document.querySelectorAll(
            '.input-wrapper input, .input-wrapper textarea'
          )
        ]
        inputs.forEach(input => {
          input.value = ''
        })
        this.dealerItems = []
        this.showDatePicker = false
        await this.$nextTick()
        this.showDatePicker = true
      },
      async submitForm () {
        this.errorMsgs = {}

        const payload = {
          ...this.form,
          date_time: this.form.date_time && this.form.date_time / 1000 // timestamp in seconds, not miliseconds
        }

        const errorFn = errors => {
          if (typeof errors !== 'object') {
            console.warn('response errors is not a object', { errors })
          }
          Object.keys(errors).forEach(errKey => {
            this.$set(this.errorMsgs, errKey, errors[errKey])
          })
        }

        const dealerId = _.get(this, 'form.dealer_id', '')
        const dealerName = this.checkNull(
          _.get(
            _.get(this, 'dealerItems', []).find(item => item.value === dealerId),
            'text',
            ''
          )
        )

        try {
          const errors = await this.submitServiceRequest({
            submitUrl: `/service${
              this._.get(this.$route, 'query.country')
                ? '?country=' + this._.get(this.$route, 'query.country')
                : ''
            }`,
            form: payload
          })

          this.pushDataToDataLayer(
            {
              events: {
                name: 'formevent',
                componentName: 'book-service',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'form-submit'
              },
              forms: {
                name: 'lead-book-service',
                step: 'form-submit',
                conversion: '1'
              },
              dealers: {
                dealer: {
                  name: dealerName,
                  dealerId,
                  city: this.checkNull(
                    _.get(
                      _.get(this, 'getMain.form.city_id.items', []).find(
                        item => item.value === _.get(this, 'form.city_id', '')
                      ),
                      'text',
                      ''
                    )
                  ),
                  zipcode: this.checkNull(
                    _.get(
                      _.get(this, 'dealerItems', []).find(
                        item => item.value === dealerId
                      ),
                      'zipcode',
                      ''
                    )
                  )
                }
              }
            },
            true,
            {
              event: 'form_send',
              formModel: _.get(this, 'form.model', ''),
              formDealer: dealerName
            }
          )

          if (errors.title) {
            await this.clearForm()
            this.$router.push({ name: 'thank-you', params: errors })
          } else {
            errorFn(errors)
          }
        } catch (e) {
          const errors = e && e.response && e.response.data
          console.error('FAILED: submitServiceRequest')
          console.log({ e })
          errorFn(errors)
        // this.$router.push({ name: 'not-found' })
        }
      },
      async fetchDealer (cityId, isFromQuery) {
        if (isNaN(Number(cityId))) {
          this.dealerItems = []
          console.warn('City id is not valid ', { cityId })
          return
        }
        const { data } = await window.axios
          .get('/dealer/list', { params: { city: cityId } })
          .catch(e => console.warn('Fetch Dealer error', { e }))
        if (!isFromQuery) {
          this.form.dealer_id = ''
          this.form.date_time = ''
          this.$refs.datePicker.date = ''
          this.$refs.datePicker.time = ''
          this.resetService()
        }
        this.form.mobility_id = ''
        this.dealerItems = data
      },
      // selectSubSelect () {

      // },
      resetService () {
        this.form.mobility_id = ''
        this.form.service_id = ''
        this.resetDatePicker()
        this.defaultForm = {}
      },
      resetDatePicker () {
        this.form.date_time = ''
        this.$refs.datePicker.date = ''
        this.$refs.datePicker.time = ''
      },

      checkNull (data) {
        if (data) return data
        return ''
      },
      pushDataToDataLayer (
        params = {},
        pushDataLayer = false,
        dataForDataLayerCustom = false
      ) {
        // dataLayer start
        const event = params.events || {}

        const page = {
          category: 'tools',
          subCategory: 'form',
          sectionlv1: 'forms',
          sectionlv2: 'book-service',
          language: _.get(this, 'currentLang', '')
        }

        const form = params.forms || {}

        window.tngaDataLayer = { event, page, form, ...params.dealers }

        if (pushDataLayer) {
          window.dataLayer.push({ event: 'formevent' })
        }
        if (dataForDataLayerCustom) {
          window.dataLayer.push(dataForDataLayerCustom)
        }
      // dataLayer end
      }
    }
  }
</script>

<style lang="scss">
.service-request-page {
  padding-bottom: 70px;

  @include mobile {
    padding-bottom: 40px;
  }

  &__form {
    padding-bottom: 25px;
    // margin-top: 70px;
    border-bottom: 1px solid $c-gray;

    @include mobile {
      padding-bottom: 5px;
      // margin-top: 40px;
    }

    &-filters {
      display: flex;
      justify-content: space-between;

      @include mobile {
        flex-direction: column;
      }
    }

    &-fields {
      @media (min-width: 767.9px) {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        > * {
          width: 336px;
        }
      }
    }

    &-input {
      // min-width: 335px;
      margin-bottom: 10px;

      @include mobile {
        min-width: 100%;
        margin-bottom: 5px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__table {
    margin: 40px 0;

    @include mobile {
      margin: 20px 0;
    }
  }

  &__editor-wrapper {
    padding-top: 40px;

    @include mobile {
      padding-top: 30px;
    }
  }

  &__editor {
    * {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      color: $c-gray-dark;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: $c-black;
    }

    h1 {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 40px;
      font-weight: 700;
      line-height: 44px;

      @include mobile {
        font-size: 24px;
        line-height: 1.42;
      }
    }

    h2 {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      // font-size: 28px;
      font-weight: 400;
      line-height: 35px;

      @include mobile {
        // font-size: 20px;
        line-height: 24px;
      }
    }

    h3 {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 21px;
      font-weight: 400;
      line-height: 30px;

      @include mobile {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
      }
    }

    h4 {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 21px;
      font-weight: 400;
      line-height: 23px;

      @include mobile {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
      }
    }

    h5,
    h6 {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 16px;
      font-weight: 900;
      line-height: 26px;

      @include mobile {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
      }
    }

    a {
      font-size: 16px;

      &:hover {
        color: $c-active;
        text-decoration: none;
        border-bottom: 0;
        transition: 0.5s;
      }

      @include mobile {
        font-size: 16px;
      }
    }

    strong {
      font-weight: 900;
    }

    ol,
    ul {
      margin-left: 20px;

      li {
        padding-left: 10px;
      }
    }
  }

  &__pd {
    display: flex;
    justify-content: center;
  }

  &__policy {
    display: flex;
    justify-content: center;
    padding-top: 40px;

    @include mobile {
      padding-top: 30px;
    }
  }

  &__submit-button-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    @include mobile {
      margin-top: 10px;
    }
  }
}

.spinner-container {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 333;
  transform: translate(-50%, -50%);
}

.lds-dual-ring {
  display: inline-block;
  width: 60px;
  height: 60px;

  &:after {
    -webkit-animation: lds-dual-ring 1.2s linear infinite;
    animation: lds-dual-ring 1.2s linear infinite;
    border-color: #000 transparent;
    border-radius: 50%;
    border-style: solid;
    border-width: 3px;
    content: " ";
    display: block;
    height: 60px;
    margin: 4px;
    width: 60px;
    animation-name: spin;
    animation-duration: 2000ms;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
